<select
  class="form-select"
  name="b2bCompany"
  id="b2bCompany"
  [(ngModel)]="value"
  (ngModelChange)="onChange($event)"
  (blur)="onTouched()"
  [compareWith]="compareCompanies"
>
  <option *ngFor="let company of companies" [ngValue]="company">
    {{ company.name }}
  </option>
</select>
